// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NpNT","title":"styles_title__3CsgG"};